import instance from '../config';

const getFacturas = async (params) => {
	try {
		const response = await instance.get('/api/factura/',{params});
		return response.data;
	} catch (error) {
		console.log(error);
		return [];
	}
}

// metodo que me obtiene todas las facturas abiertas
const getFacturasAbiertas = async () => {
	try {
		const response = await instance.get('/api/abiertas/factura');
		return response.data;
	} catch (error) {
		console.log(error);
		return [];
	}
}

// metodo para obtener detalle factura para una factura
const obtenerDetalleFactura = async (id) => {
	try {
		const response = await instance.get(`/api/factura/${id}`);
		return response.data;
	} catch (error) {
		console.error(error);
		return [];
	}
};


// Metodo para crear una factura 
const Postfactura = async (
	id_conductor,
	id_user,
	idCliente, 
	estado, 
	subtotal,
	fechaDePago, 
	descuento, 
	financiado, 
	total,
	transporte,
	tipo,
	quien_recibe,
	direccion
    ) => {

	try {
		const response = await instance.post('/api/factura', {id_conductor, id_user,idCliente, estado, subtotal,fechaDePago, descuento, financiado, total,transporte,tipo,quien_recibe,direccion });
		return response.data;
	} catch (error) {
		return error.response.data;

	}
}

// Metodo para crear una factura detalle
const PostfacturaDetalle = async (isventa,idFactura,dataProductos) => {

	try {
		const response = await instance.post('/api/detallefactura', {isventa, idFactura,dataProductos });
		return response.data;
	} catch (error) {
		return error.response.data;

	}
}

// metodo para buscar una factura 
const BuscarFactura = async (numeroFactura) => {
	try {
		const response = await instance.get(`/api/facturanumero/${numeroFactura}`);
		return response.data;
	} catch (error) {
		console.error(error);
		return error.response.data;
	}
};

// Metodo para eliminar una factura
const EliminarFactura = async (id) => {
    try {
        const response = await instance.delete(`/api/factura/${id}`);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

const PostAbonoFactura = async (facturaId, monto, descripcion,idUser) => {
	try {
		const response = await instance.post('/api/abono', { facturaId, monto, descripcion,idUser });
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

// Metodo para actualizar uan factura
const Editarfactura = async (id,id_user,estado,subtotal,fechaDePago,descuento,financiado,total,transporte,tipo,quien_recibe, direccion,nombre_conductor,celular_conductor,fecha_creacion) => {
    try {
        const response = await instance.put(`/api/factura/${id}`,{id_user,estado,subtotal,fechaDePago,descuento,financiado,total,transporte,tipo,quien_recibe, direccion,nombre_conductor,celular_conductor,fecha_creacion});
        return response.data;
    } catch (error) {
        console.error(error);
        return error.response.data;
    }
}

const ActualizarAbono = async (id, monto) => {
	try {
		const response = await instance.put(`/api/abono/${id}`, { monto });
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

// Metodo para eliminar un abono 
const EliminarAbono = async (id) => {
	try {
		const response = await instance.delete(`/api/abono/${id}`);
		return response.data;
	} catch (error) {
		return error.response.data;
	}
};

//Metodo para eliminar  un detalle de una factura con ID unico 
const deleteDetalleVenta= async (id)=>{
	try {
		const response = await instance.delete(`/api/detallefactura/${id}`);
        return response.data;
	} catch (error) {
		return error.response.data;
	}
}

//Metodo para editar las cantidades  de  una venta 
const updateDetalleVenta= async (id, data)=>{
	try {
		const response = await instance.put(`/api/detallefactura/${id}`, data);
        return response.data;
	} catch (error) {
		return error.response.data;
	}
}

// Metodo para cambiar el cliente de una cotizacion ya exixtente 
const cambiarClienteCotizacionFacturas = async (id, nuevoClienteId) => {
  try {
    const response = await instance.patch(`/api/cambioF/venta/${id}`, { nuevoClienteId });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export {
	getFacturas,
	obtenerDetalleFactura,
	Postfactura,
	PostfacturaDetalle,
	BuscarFactura,
	EliminarFactura,
	PostAbonoFactura,
	Editarfactura,
	ActualizarAbono,
	EliminarAbono,
	getFacturasAbiertas,
	deleteDetalleVenta,
	updateDetalleVenta,
	cambiarClienteCotizacionFacturas
};

